'use strict';require('../../style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/table/style/css.web.js
// module id = 280
// module chunks = 0